module.exports = __webpack_public_path__ + "static/media/kw.bf8f5dd4.svg";